// extracted by mini-css-extract-plugin
module.exports = {"card":"ProductsBrandLogoCard_card_Z9fqy","image":"ProductsBrandLogoCard_image_NJg2V"};